module.exports = __webpack_public_path__ + "static/media/15UN-Habitat15.e0aa9ae5.jpg";